import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { VTCContent } from "@/components/pages/vtc/VTC";
import { queryPrestige } from "@/strapiQuery/prestige";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const prestigeContentPromise = getStrapiEntity<VTCContent>(
    "prestige",
    queryPrestige
  );

  const [layout, prestigeContent] = await Promise.all([
    layoutPromise,
    prestigeContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...prestigeContent,
      intlMessages,
      defaultCanonicalRoute: routes.prestige,
    },
    revalidate: 10,
  };
};

export { VTC as default } from "@/components/pages/vtc/VTC";
